export default {
  maps: {
    pageTitle: 'Hărți ORS',
    Places: 'Locuri',
    isochrones: 'Izocronii',
    placeNameRequired: 'Numele locului este necesar',
    altitude: 'Variația altitudinii',
    settings: 'Setări',
    toggleAccessibleMode: 'Comutați modul accesibil',
    aboutTitle: 'Despre ORS',
    updateSearch: 'Căutați în această zonă',
    updateSearchAfterZoomOrCenterChange: 'Actualizarea căutării după modificarea zoom-ului sau a centrului',
    pageNotFound: 'Pagina nu a fost găsită. Verificați dacă URL-ul nu este deformat',
  }
}
